/* ==========================================================================
   EVERPRET MENU — assets/everpret-menu.js
   One small, targeted fix: correctly position the desktop hover dropdowns
   (Collections, Gifting) and mega-menu (Shop by Category) under their own
   trigger, and keep them on-screen.

   Why this is needed: the theme's own CSS intentionally leaves the dropdown's
   horizontal position unset (`position: absolute` with no left/right), relying
   on the browser's "static position" fallback to place it under the trigger.
   That fallback does not resolve correctly for these panels once nested inside
   the <details>/custom-element chain used here, so every dropdown was
   collapsing to the left edge of the header instead of sitting under its own
   link. This listens for the native `toggle` event <details> already fires
   (however it was opened — click or the theme's own hover trigger) and sets
   the panel's left position from real, measured geometry. No new interaction
   behaviour is added; open/close/hover is still entirely the theme's own.
   ========================================================================== */
(function () {
  'use strict';

  function positionPanel(details) {
    var panel = details.querySelector(':scope > .header__dropdown-menu, :scope > .mega-menu');
    if (!panel) return;

    var parentRect = panel.offsetParent ? panel.offsetParent.getBoundingClientRect() : { left: 0 };
    var triggerRect = details.getBoundingClientRect();
    var panelWidth = panel.offsetWidth;
    var margin = 16;

    var left = triggerRect.left - parentRect.left;

    if (triggerRect.left + panelWidth > window.innerWidth - margin) {
      left = (window.innerWidth - margin - panelWidth) - parentRect.left;
    }
    if (parentRect.left + left < margin) {
      left = margin - parentRect.left;
    }

    panel.style.setProperty('left', left + 'px', 'important');
  }

  function onToggle(event) {
    var details = event.target;
    if (!details.open) return;
    positionPanel(details);
  }

  function init(root) {
    root.querySelectorAll('.everpret-menu .header__menu-disclosure').forEach(function (details) {
      if (details.__everpretMenuPositioned) return;
      details.__everpretMenuPositioned = true;
      details.addEventListener('toggle', onToggle);
    });
  }

  // Re-clamp on resize while a panel is open, so it never sits off-screen mid-viewport-change
  window.addEventListener('resize', function () {
    document.querySelectorAll('.everpret-menu .header__menu-disclosure[open]').forEach(positionPanel);
  });

  // Theme editor: re-bind if the header section reloads
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();